let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3B86E")).then(() => parcelRequire('YCgrc'));